// extracted by mini-css-extract-plugin
export var methodBackgroundClassName = "styles-module--methodBackgroundClassName--2gTXz";
export var priceCardBackgroundClassName = "styles-module--priceCardBackgroundClassName--lp5oL";